'use client'

import React from "react";
import styles from "./NotSureWhichSpecializationtoChooseLp.module.scss";
import { useModalDispatch } from "@/context/ModalContext";
import { pushToDataLayer } from "@/helpers/gtag";
import { GAEvent } from "@/helpers/gaEvents";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { ModalTypes, IModalActions } from "@/types/modal";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";

interface NotSureWhichSpecializationtoChooseProps {
  associatedPrograms?: any;
}

export default function NotSureWhichSpecializationtoChooseLp({ associatedPrograms }: NotSureWhichSpecializationtoChooseProps) {

  const modalDispatch = useModalDispatch();
  const { LEAD_INITIATE } = GAEvent;

  const modalVariant = "specializationHelp";

  const handleOpenModal = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          associatedPrograms,
          isLandingPage: true,
          modalVariant,
          rfiCase: "THANK_YOU_PAGE_CASE",
          isLambdaAPI: true
        },
      },
    });

    pushToDataLayer({
      event: LEAD_INITIATE,
      cta_text: "Get Personalized Guidance",
      section_name: "Middle Banner",
      page_type: getGlobalStateValue("pageType"),
      page_url: window.location.href,
    });

    updateStateSession({
      parentSection: "Middle Banner",
      leadStartingCta: "Get Personalized Guidance",
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.containerInner}>
        <div className={styles.bgImageWrapper} aria-hidden="true">
          <UnivoImage
            className={styles.bgImage}
            src={IMAGE_ASSETS.specializationHelpBg}
            alt="Specialization amity online"
            fill
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>
        <div className={styles.content}>
          <div className={styles.topContent}>
            <div className={styles.badge}>
              learners across <span className="mr-[4px] ml-[4px] lining-nums">150+</span> countries
            </div>
            <div className={styles.headingGroup}>
              <h2 className={styles.heading}>
                The World&apos;s Digital Campus
              </h2>
              <div className={styles.subheading}>
                <span>FOR EVERYONE,</span>
                <span>EVERYWHERE.</span>
              </div>
            </div>
          </div>
          <div className={styles.ctaWrapper}>
            <button className={styles.cta} onClick={handleOpenModal}>
              Join Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
